import {
  Box,
  Checkbox,
  Divider,
  Grid2,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuItemMui from "@mui/material/MenuItem";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { CalendarMonthOutlined, CancelOutlined } from "@mui/icons-material";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const MaterialGIPipesReportDetails = ({
  addTestHandle,
  eachTest,
  mainData,
  setMainData,
  isNonMobile,
}) => {
  const materialTestTypes = [
    { id: "39", label: `${'GI Pipe Ø20mm / (1/2")'}`, value: "39" },
    { id: "1", label: `${'GI Pipe Ø25mm / (3/4")'}`, value: "1" },
    { id: "38", label: `${'GI Pipe Ø32mm / (1")'}`, value: "38" },
    { id: "41", label: `${"GI Pipe Ø38mm"}`, value: "41" },
    { id: "2", label: `${'GI Pipe Ø40mm / (1 1/4")'}`, value: "2" },
    { id: "37", label: `${'GI Pipe Ø47mm / (1 1/2")'}`, value: "37" },
    { id: "44", label: "GI Pipe Ø50mm", value: "44" },
    { id: "36", label: `${'GI Pipe Ø59mm / (2")'}`, value: "36" },
    { id: "3", label: "GI Pipe Ø60mm", value: "3" },
    { id: "52", label: "GI Pipe Ø63mm", value: "52" },
    { id: "35", label: `${'GI Pipe Ø75mm / (2 1/2")'}`, value: "35" },
    { id: "34", label: `${'GI Pipe Ø88mm / (3")'}`, value: "34" },
    { id: "4", label: "GI Pipe Ø90mm", value: "4" },
    { id: "33", label: `${'GI Pipe Ø114mm / (4")'}`, value: "33" },
    { id: "32", label: `${'GI Pipe Ø140mm / (5")'}`, value: "32" },
    { id: "31", label: `${'GI Pipe Ø165mm / (6")'}`, value: "31" },
    { id: "30", label: `${'GI Pipe Ø219mm / (8")'}`, value: "30" },
    { id: "40", label: `${"GI Weld Mesh"}`, value: "40" },
    { id: "5", label: "Angle iron 25x25x5 (mm)", value: "5" },
    { id: "6", label: "Angle iron 25x25x6 (mm)", value: "6" },
    { id: "7", label: "Angle iron 40x40x5 (mm)", value: "7" },
    { id: "8", label: "Angle iron 40x40x6 (mm)", value: "8" },
    { id: "9", label: "Angle iron 50x50x5 (mm)", value: "9" },
    { id: "10", label: "Angle iron 50x50x6 (mm)", value: "10" },
    { id: "50", label: "Angle iron 63x63x6 (mm)", value: "50" },
    { id: "47", label: "Angle iron 65x65x5 (mm)", value: "47" },
    { id: "11", label: "Angle iron 65x65x6 (mm)", value: "11" },
    { id: "51", label: "Angle iron 75x75x5 (mm)", value: "51" },
    { id: "12", label: "Angle iron 75x75x6 (mm)", value: "12" },
    { id: "13", label: "PVC coated chain link gauge 10", value: "13" },
    { id: "14", label: "PVC coated chain link gauge 12", value: "14" },
    { id: "15", label: "C Purlin 100x50 (mm)", value: "15" },
    { id: "16", label: "C Purlin 150x65 (mm)", value: "16" },
    { id: "17", label: "C Purlin 75x38 (mm)", value: "17" },
    { id: "18", label: "Flat iron 20x6 (mm)", value: "18" },
    { id: "26", label: "Flat iron 25x5 (mm)", value: "26" },
    { id: "19", label: "Flat iron 30x6 (mm)", value: "19" },
    { id: "29", label: "Box bar 20x20 (mm)", value: "29" },
    { id: "20", label: "Box bar 25x25 (mm)", value: "20" },
    { id: "23", label: "Box bar 25x50 (mm)", value: "23" },
    { id: "28", label: "Box bar 38x38 (mm)", value: "28" },
    { id: "27", label: "Box bar 38x75 (mm)", value: "27" },
    { id: "21", label: "Box bar 40x40 (mm)", value: "21" },
    { id: "22", label: "Box bar 50x20 (mm)", value: "22" },
    { id: "42", label: "Box bar 50x50 (mm)", value: "42" },
    { id: "49", label: "Box bar 75x75 (mm)", value: "49" },
    { id: "43", label: "Box bar 50x100 (mm)", value: "43" },
    { id: "24", label: "Mild steel Ø8mm", value: "24" },
    { id: "25", label: "Mild steel Ø10mm", value: "25" },
    { id: "46", label: "Mild steel Ø12mm", value: "46" },
    { id: "45", label: "Zink Aluminum  Flat sheet (Gauge 18)", value: "45" },
    { id: "48", label: "UPVC Pipe", value: "48" },
  ];
  // 52
  const handleDateOfTest = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfTest: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    concreteMixture: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  const checkFieldsHandle = () => {
    if (mainData.concreteMixture === "") {
      setErrorCheck((pre) => ({
        ...pre,
        concreteMixture: {
          ...pre.concreteMixture,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        concreteMixture: {
          ...pre.concreteMixture,
          error: false,
        },
      }));
    }

    if (mainData.areaOfCube === "") {
      setErrorCheck((pre) => ({
        ...pre,
        areaOfCube: {
          ...pre.areaOfCube,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        areaOfCube: {
          ...pre.areaOfCube,
          error: false,
        },
      }));
    }

    if (eachTest.weight === "") {
      setErrorCheck((pre) => ({
        ...pre,
        weight: {
          ...pre.weight,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        weight: {
          ...pre.weight,
          error: false,
        },
      }));
    }
    if (eachTest.compressiveStrength === "") {
      setErrorCheck((pre) => ({
        ...pre,
        compressiveStrength: {
          ...pre.compressiveStrength,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        compressiveStrength: {
          ...pre.compressiveStrength,
          error: false,
        },
      }));
    }
    // console.log("maindata", mainData);

    addTestHandle();
  };

  const handleSetColor = (serialNo, color, testName) => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo
          ? { ...test, color: color, concreteMixture: testName }
          : test,
      ),
    }));
  };

  const handleDimension = (serialNo, dimension, testName) => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo ? { ...test, description: dimension } : test,
      ),
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        display="grid"
        gap={0.5}
        alignItems="center"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 6",
          },
        }}
      >
        <DemoContainer
          alignContent="center"
          components={["DatePicker"]}
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          <Box style={{ width: "190px" }}>
            <DatePicker
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: "40px",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                },
              }}
              label="Date of test"
              timezone="Asia/Colombo"
              format="YYYY-MM-DD"
              // error={errorCheck.dateOfTest.error}
              value={
                mainData.dateOfTest
                  ? dayjs(mainData.dateOfTest).tz("Asia/Colombo", true)
                  : dayjs().tz("Asia/Colombo", true)
              }
              onChange={(newVal) => {
                const colomboTime = newVal?.tz("Asia/Colombo", true);
                handleDateOfTest(colomboTime);
              }}
            />
          </Box>
        </DemoContainer>
      </Box>
      <Divider sx={{ margin: "5px 0px 5px 0" }} />

      <Box justifyItems="center">
        <Paper
          variant="elevation"
          elevation={2}
          sx={{ padding: "20px", width: "80%" }}
        >
          {mainData.labTestsDataFromSubs?.map((data, index) => (
            <Grid2 container columnSpacing={0.5} width="100%">
              <Grid2 size={1} alignContent="center">
                <Typography variant="subtitle1" color="info" textAlign="center">
                  NO.
                </Typography>

                <Typography variant="h5" textAlign="center">
                  {data.serialNo === undefined
                    ? "AUTO"
                    : String(data.serialNo) + ")"}
                </Typography>
              </Grid2>
              <Grid2 size={6} alignContent="center">
                <TextField
                  select
                  label="Material Type"
                  fullWidth
                  size="small"
                  defaultValue=""
                  sx={{ marginTop: "5px" }}
                  value={data.color} // test type id
                  onChange={(e) => {
                    const selectedValue = e.target.value;

                    // Find the selected material to get both value and label
                    const selectedMaterial = materialTestTypes.find(
                      (item) => item.value === selectedValue,
                    );

                    // You can access both the value and label
                    const selectedLabel = selectedMaterial
                      ? selectedMaterial.label
                      : "";

                    // Pass additional data to your handler
                    handleSetColor(data.serialNo, selectedValue, selectedLabel);
                  }}
                >
                  {materialTestTypes.map((data) => (
                    <MenuItemMui
                      key={data.id}
                      data-label={data.label}
                      value={data.value}
                    >
                      {data.label}
                    </MenuItemMui>
                  ))}
                </TextField>
              </Grid2>

              <Grid2 size={5} alignContent="center">
                <TextField
                  value={data.description}
                  fullWidth
                  variant="outlined"
                  label="Dimension "
                  size="small"
                  onChange={(e) =>
                    handleDimension(data.serialNo, e.target.value)
                  }
                  sx={{
                    marginTop: "5px",
                    "& input": {
                      textAlign: "start",
                    },
                  }}
                />
              </Grid2>
              {/* <Grid2 size={2} justifyItems="center">
                <Box>
                  <IconButton
                    onClick={() => handleRemoveSeleced(data.serialNo)}
                    color="error"
                    aria-label="delete"
                  >
                    <Delete />
                  </IconButton>
                </Box>
              </Grid2> */}
              <Grid2 size={12} justifyItems="center">
                <Divider width="100%" />
              </Grid2>
            </Grid2>
          ))}
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default MaterialGIPipesReportDetails;
